import localFont from 'next/font/local'

export enum FontVariableEnum {
  Inter = '--font-family-inter',
  Averta = '--font-family-averta',
}

export const interFont = localFont({
  src: [
    { path: '../../../public/fonts/Inter-Regular.woff2', weight: '400', style: 'normal' },
    { path: '../../../public/fonts/Inter-Bold.woff2', weight: '700', style: 'normal' },
    { path: '../../../public/fonts/Inter-SemiBold.woff2', weight: '600', style: 'normal' },
    { path: '../../../public/fonts/Inter-Medium.woff2', weight: '500', style: 'normal' },
  ],
  variable: FontVariableEnum.Inter,
})

export const avertaFont = localFont({
  src: [
    { path: '../../../public/fonts/averta/Averta-bold.woff2', weight: '700', style: 'normal' },
    { path: '../../../public/fonts/averta/Averta-light.woff2', weight: '300', style: 'normal' },
    { path: '../../../public/fonts/averta/Averta-semibold.woff2', weight: '600', style: 'normal' },
    { path: '../../../public/fonts/averta/Averta-thin.woff2', weight: '100', style: 'normal' },
  ],
  variable: FontVariableEnum.Averta,
})
